import SubLanding from "@/components/SubLanding";
export default function AIStoicCoach() { return <SubLanding slug="ai-stoic-coach" />; }
